class RecommendedProducts extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (window.Swiper) {
            const recommendedSwiper = new Swiper(this.querySelector('.recommendedSwiper'), {
                slidesPerView: 2,
                spaceBetween: 8,
                pagination: {
                    el: '.recommendedSwiperPagination',
                },
                navigation: {
                    nextEl: '.recommendedSwiperNext',
                    prevEl: '.recommendedSwiperPrev',
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                        spaceBetween: 8,
                    },
                    1000: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    }
                }
            });

            const slidesToRemove = [];
            for (const slide of recommendedSwiper.slides) {
                if (!slide.querySelector(".collectionItem")) {
                    slidesToRemove.push(parseInt(slide.dataset.index));
                }
            }
            recommendedSwiper.removeSlide(slidesToRemove);
            recommendedSwiper.update();

            // color swatches on the cards are handled by collection-item.js
        }
    }
}

if (!customElements.get('recommended-products')) {
    customElements.define('recommended-products', RecommendedProducts);
}